import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { formatRecordingIdDateParts } from "../../../utils/results/recordingIdTime";
import { isManualAudioCompleteDoc } from "../../../utils/results/manualAudioStatus";
import ResultViewScaffold from "../ResultViewScaffold";

function ManualAudioResultViewImpl({ docId, onFinish }) {
  const { t, i18n } = useTranslation();

  const recordingTime = useMemo(
    () =>
      formatRecordingIdDateParts(
        docId,
        i18n.resolvedLanguage || i18n.language || "en-GB",
      ),
    [docId, i18n.resolvedLanguage, i18n.language],
  );

  return (
    <ResultViewScaffold
      title={t(
        "result.manualAudio.completeTitle",
        "Manual audio recording complete",
      )}
      recordingTime={recordingTime}
      onFinish={onFinish}
    />
  );
}

const ManualAudioResultView = memo(ManualAudioResultViewImpl);

ManualAudioResultView.isReady = (data) => {
  return isManualAudioCompleteDoc(data);
};

export default ManualAudioResultView;
